module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei7.svg";